import axios from 'axios';
import { useAuth } from 'context/AuthContext';

const API_BASE_URL = process.env.REACT_APP_FAST_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

const NO_REDIRECT_ENDPOINTS = [
  '/api/user/re-login',
  '/api/user/login',
  '/api/signup',
  '/api/verify-otp',
  '/api/save-password',
  '/api/save-google-user',
  '/api/reset-password'
];

axiosInstance.interceptors.request.use(
  (config) => {
    const getTokenFromStorage = () => {
      try {
        const CryptoJS = require('crypto-js');
        const SECRET_KEY = process.env.REACT_APP_STORAGE_SECRET;
        const encrypted = localStorage.getItem('auth_token');
        if (!encrypted) return null;
        
        const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return decryptedString ? JSON.parse(decryptedString) : null;
      } catch (error) {
        return null;
      }
    };

    const token = getTokenFromStorage();
    
    if (token) {
      try {
        const { jwtDecode } = require('jwt-decode');
        const decoded = jwtDecode(token);
        
        const isExpired = decoded.exp * 1000 < Date.now() + 5 * 60 * 1000;
        
        if (isExpired) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('auth_user');
          localStorage.removeItem('current_domain');
          localStorage.removeItem('user_sites');
          window.location.href = '/login';
          return Promise.reject(new Error('Token expired'));
        }
        
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        localStorage.removeItem('current_domain');
        localStorage.removeItem('user_sites');
        window.location.href = '/login';
        return Promise.reject(new Error('Invalid token'));
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const shouldRedirect = !NO_REDIRECT_ENDPOINTS.some(endpoint => 
      url.includes(endpoint)
    );
    
    if (error.response?.status === 401 && shouldRedirect) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      localStorage.removeItem('current_domain');
      localStorage.removeItem('user_sites');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;